import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";

function Contact() {
	const [name, setName] = React.useState("");
	const [email, setEmail] = React.useState("");
	const [message, setMessage] = React.useState("");

	function encode(data) {
		return Object.keys(data)
			.map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
			.join("&");
	}

	function handleSubmit(e) {
		e.preventDefault();
		fetch("/", {
			method: "POST",
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
			body: encode({ "form-name": "contact", name, email, message }),
		})
			.then(() => alert("Message sent!"))
			.catch((error) => alert(error));
	}
	return (
		<section id="contact-me">
			<p>Intrigued?</p>
			<h1>Let's work together!</h1>
			<div className="all-container">
				<form data-netlify="true" name="contact" onSubmit={handleSubmit} className="contact-form">
					{/*<div className='input form-name'>*/}
					<p className="message-intro">Send me a message:</p>
					<label htmlFor="name" className="input contact-name">
						Your name
					</label>
					<input
						type="text"
						id="name"
						name="name"
						className="input contact-name"
						onChange={(e) => setName(e.target.value)}
					/>
					{/*</div>*/}
					{/*<div className='input form-email'>*/}
					<label htmlFor="email" className="input contact-email">
						Your contact email
					</label>
					<input
						type="email"
						id="email"
						name="email"
						className="input contact-name"
						onChange={(e) => setEmail(e.target.value)}
					/>
					{/*</div>*/}
					{/*<div className='input form-text'> */}
					<label htmlFor="message">Message</label>
					<textarea
						id="message"
						name="message"
						className=""
						onChange={(e) => setMessage(e.target.value)}
					/>
					{/*</div>*/}

					<button type="submit" className="">
						Submit
					</button>
				</form>

				<div className="social-container">
					<p className="social-p">or find me on:</p>
					<a
						href="https://github.com/GiuliaPassoni"
						target="_blank"
						className="social-link"
						id="profile-link"
						rel="noreferrer"
					>
						<FontAwesomeIcon icon={faGithub} />
						{/*<FontAwesomeIcon icon={brands("github")} />*/}
						{/*<div className='social'></div>*/}
					</a>

					{/*<a href='https://www.instagram.com/giulipassoni/' target='_blank' className='social-link'*/}
					{/*   rel="noreferrer">*/}
					{/*    <FontAwesomeIcon icon={brands('instagram')} />*/}
					{/*    /!*<div className='social'></div>*!/*/}
					{/*</a>*/}

					<a
						href="mailto:giulia.passoni95@gmail.com"
						target="_blank"
						className="social-link"
						rel="noreferrer"
					>
						{/*<FontAwesomeIcon icon={solid("envelope")} />*/}
						<FontAwesomeIcon icon={faEnvelope} />
						{/*<div className='social'></div>*/}
					</a>
				</div>
			</div>
		</section>
	);
}

export default Contact;
